import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'

export const useQuotesStore = defineStore('quotes', {
  state: () => ({
    submittedCart: null,
    quotesForWidget: [],
    totalSubmittedQuotes: 0,
    totalReadyQuotes: 0,
  }),

  actions: {
    async getQuoteDetails(quoteCode) {
      const { data: quoteDetailsData } = await api.quotes.getQuoteDetails(quoteCode)
      return quoteDetailsData
    },

    async getQuotesForWidget() {
      const requestParams = {
        states: 'SUBMITTED,READY',
        sort: 'byDateDESC',
        pageSize: 5,
        statisticsByStatuses: true,
        showCompanyQuotes: true,
      }
      const response = await api.quotes.getQuotes('', requestParams)
      const { quotes = [], statisticsByStatuses = [] } = response.data
      const totalSubmittedQuotes =
        statisticsByStatuses.find((el) => el.name === 'Submitted')?.count || 0
      const totalReadyQuotes =
        statisticsByStatuses.find((el) => el.name === 'Ready to Order')?.count || 0
      this.quotesForWidget = quotes
      this.totalSubmittedQuotes = totalSubmittedQuotes
      this.totalReadyQuotes = totalReadyQuotes
    },

    setSubmittedCart(submittedCart) {
      this.submittedCart = submittedCart
    },

    resetState() {
      this.$reset()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useQuotesStore, import.meta.hot))
}
